import { useParams } from 'react-router-dom';
import CookbookMealListContainer from './CookbookMealListContainer';
import {
  useTimestamp,
  CookbookTagsConnectorApollo,
  CookbookCategoriesConnectorApollo,
  CookbookMealListConnectorApollo,
  AddFavoriteCookbookMealConnectorApollo,
  RemoveFavoriteCookbookMealConnectorApollo,
} from '@front-activerse/common-components';

export const CookbookMealListPage: React.FC = () => {
  const { timestamp1 } = useTimestamp();
  const { categoryId, mealTypeTagId, dietTypeTagId } = useParams();
  const dietTypeTags = [dietTypeTagId ? +dietTypeTagId : 0];

  return (
    <CookbookTagsConnectorApollo dietTypeTags={dietTypeTags}>
      {(cookbookTagListData) => (
        <CookbookCategoriesConnectorApollo>
          {(cookbookCategoriesData) => (
            <CookbookMealListConnectorApollo
              searchCriteria={{
                categories: [categoryId ? +categoryId : 0],
                dietTypeTags: [dietTypeTagId ? +dietTypeTagId : 0],
                mealTypeTags: [mealTypeTagId ? +mealTypeTagId : 0],
              }}
            >
              {(cookbookMealListData) => (
                <AddFavoriteCookbookMealConnectorApollo>
                  {({ addCookbookMealToFavorite }) => (
                    <RemoveFavoriteCookbookMealConnectorApollo>
                      {({ removeCookbookMealFromFavorites }) => (
                        <CookbookMealListContainer
                          categoryId={categoryId}
                          mealTypeTagId={mealTypeTagId}
                          {...cookbookMealListData}
                          {...cookbookCategoriesData}
                          {...cookbookTagListData}
                          loading={
                            cookbookMealListData.loading ||
                            cookbookCategoriesData.loading ||
                            cookbookTagListData.loading
                          }
                          addToFavorites={addCookbookMealToFavorite}
                          removeFromFavorites={removeCookbookMealFromFavorites}
                          key={timestamp1}
                        />
                      )}
                    </RemoveFavoriteCookbookMealConnectorApollo>
                  )}
                </AddFavoriteCookbookMealConnectorApollo>
              )}
            </CookbookMealListConnectorApollo>
          )}
        </CookbookCategoriesConnectorApollo>
      )}
    </CookbookTagsConnectorApollo>
  );
};

export default CookbookMealListPage;
